var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 10.9572H1.04346C0.467168 10.9572 0 11.4243 0 12.0006C0 12.5769 0.467168 13.0441 1.04346 13.0441H22.9565C23.5328 13.0441 24 12.5769 24 12.0006C24 11.4243 23.5328 10.9572 22.9565 10.9572Z",
    fill: "#374957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 5.73933H22.9565C23.5328 5.73933 24 5.27216 24 4.69587C24 4.11957 23.5328 3.6524 22.9565 3.6524H1.04346C0.467168 3.6524 0 4.11957 0 4.69587C0 5.27216 0.467168 5.73933 1.04346 5.73933Z",
    fill: "#374957"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 18.261H1.04346C0.467168 18.261 0 18.7282 0 19.3045C0 19.8808 0.467168 20.348 1.04346 20.348H22.9565C23.5328 20.348 24 19.8808 24 19.3045C24 18.7282 23.5328 18.261 22.9565 18.261Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d7e933701222aeb8e4aac99b0ce54f76.svg";
export { ForwardRef as ReactComponent };